import 'common';
import 'lazysizes';
import 'components/hamburger_mobile_menu';

import(/* webpackChunkName: "AddressSearchForm" */ 'address_search_form').then(module =>
  new module.AddressSearchForm().mount(),
);

import(/* webpackChunkName: "dateTimeFieldsPickers" */ 'date_time_fields_pickers').then(module =>
  module.dateTimeFieldsPickers(),
);

import(/* webpackChunkName: "Dropdown" */ 'dropdown').then(module => new module.Dropdown().mount());

import(/* webpackChunkName: "sideNav" */ 'side_nav').then(module => module.sideNav());

import(/* webpackChunkName: "Accordion" */ 'accordion').then(module =>
  new module.Accordion().mount(),
);

import(/* webpackChunkName: "fetchCaterers" */ 'caterers_near_me/fetch_caterers').then(module =>
  module.fetchCaterers(),
);

if (document.getElementById('promo_auto_applied_banner')) {
  import(/* webpackChunkName: "promoAutoAppliedManager" */ 'promo_auto_applied_manager').then(
    module => {
      module.promoAutoAppliedManager();
    },
  );
}

import(/* webpackChunkName: "preciseLocation" */ '../precise_location').then(module => {
  const perciseLocationButton = document.getElementById('use-precise-location');
  if (perciseLocationButton) {
    perciseLocationButton.addEventListener('click', module.fetchAndFillPreciseLocation);
  }
});
